<ng-template #isLoadingGroup>
    <div fxLayout="row" fxLayoutGap="20px" *ngFor="let item of createRange(30)">
        <ngx-skeleton-loader count="1" [theme]="{
        height: '20px',
        width: '30px',
        'margin-bottom': '10px'
          }"></ngx-skeleton-loader>

        <ngx-skeleton-loader class="w-100" count="1" [theme]="{
        height: '20px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #isLoading>
    <ngx-skeleton-loader class="w-100" count="1" [theme]="{
        height: '30px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
</ng-template>

<div class="masterSorter" fxLayout.lt-sm="row wrap" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="20px"
    fxLayoutAlign="start space-between">
    <div fxLayout="column" fxFlex.lt-sm="100" fxFlex.gt-sm="50" id="master-sorter-1">
        <mat-card>
            <div fxLayout="column">
                <mat-card-title class="mb-15" *ngIf="isLoading$ == false; else isLoading"> <span [innerHTML]="currentCategory?.name"></span>
                </mat-card-title>
                <div fxLayout="row" fxLayoutGap="10px" class="masterSorter__buttonWrapper mb-10">
                    <button mat-raised-button (click)="onEdit(currentCategory)" color="accent" fxFlexAlign="center" *ngIf="editOption">
                        <mat-icon class="mr-0">edit</mat-icon><span fxHide.lt-xl="true">{{ "edit" | translate }}</span>
                    </button>
                    <div matTooltip="You can not delete all {{lastItemText}} at all times."
                    [matTooltipDisabled]="itemsLength > 1" matTooltipClass="tooltip">
                    <button mat-raised-button (click)="onDelete(currentCategory)" color="accent" fxFlexAlign="center" [disabled]="itemsLength == 1" *ngIf="deleteOption">
                        <mat-icon class="mr-0">delete</mat-icon><span fxHide.lt-xl="true">{{ "delete" | translate
                            }}</span>
                    </button>
                </div>
                    <button mat-raised-button color="accent" fxFlexAlign="center" [matMenuTriggerFor]="menu">
                        <mat-icon>remove_red_eye</mat-icon> {{ "view" | translate }}
                    </button>
                    <button mat-raised-button color="accent" fxFlexAlign="center" (click)="onSort()">
                        <i class="material-icons">text_rotate_vertical</i>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button (click)="onSetPrdCode(2)" mat-menu-item fxFlexAlign="center">
                            SKU
                        </button>
                        <button (click)="onRemovePrdCode(2)" mat-menu-item fxFlexAlign="center">
                            {{ "description" | translate }}
                        </button>
                    </mat-menu>
                </div>
            </div>
            <mat-form-field (keyup)="onApplyFilterInCategory($event)" autocomplete="off" appearance="outline"
                floatLabel="always" class="w-100">
                <mat-label>{{ "searchProducts" | translate }}</mat-label>
                <input matInput [(ngModel)]="leftValue" autocomplete="off" id="masterSorter__inCatInput">
                <button *ngIf="leftValue != ''" matSuffix mat-icon-button aria-label="Clear"
                    (click)="onClearLeftValue()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </mat-card>
        <mat-card class="master-count__column mt-18" fxFlex.lt-md="100" cdkDropList cdkDropListAutoScrollStep="45"
            [cdkDropListData]="inCat$" (cdkDropListDropped)="onDrop($event)">
            <div *ngIf="isLoading$ == false; else isLoadingGroup">
                <div [ngSwitch]="inCat$.length">
                    <app-no-results *ngSwitchCase="0"
                        key="{{ type == 'category' ? 'products.category' : 'products.area' }}">
                    </app-no-results>
                    <ng-container *ngSwitchDefault>
                        <div *ngFor="let p of inCat$; let i = index" cdkDrag class="drag-and-drop__row" matRipple
                            [matRippleColor]="rippleRemoveColor" (click)="onToggleLeftSelection(p)">
                            <mat-icon>drag_indicator</mat-icon>
                            <span class="master-count__in-cat__item"><span [innerHTML]="columns$.includes(2) ? p.prdCode : p.prdNameEn"> </span></span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </mat-card>
    </div>
    <div fxLayout="column" fxFlex.lt-sm="100" fxFlex.gt-sm="50" id="master-sorter-2">
        <mat-card [hidden]="selectedSection$ != 2 && isHandset$ == true">
            <div fxLayout="row" fxLayout="column">
                <mat-card-title class="mb-15" *ngIf="isLoading$ == false; else isLoading">{{ "availableProducts" |
                    translate }}
                </mat-card-title>
                <div fxLayout="row" fxLayoutGap="10px" class="masterSorter__buttonWrapper mb-10">
                    <button mat-raised-button color="accent" fxFlexAlign="center" [matMenuTriggerFor]="menu2">
                        <mat-icon>remove_red_eye</mat-icon> {{ "view" | translate }}
                    </button>
                    <mat-menu #menu2="matMenu">
                        <button (click)="onSetPrdCode(3)" mat-menu-item fxFlexAlign="center">
                            SKU
                        </button>
                        <button (click)="onRemovePrdCode(3)" mat-menu-item fxFlexAlign="center">
                            {{ "description" | translate }}
                        </button>
                    </mat-menu>
                </div>
                <mat-form-field (keyup)="onApplyFilterNotInCategory($event)" appearance="outline" floatLabel="always"
                    class="w-100">
                    <mat-label>{{ "searchProducts" | translate }}</mat-label>
                    <input autocomplete="off" matInput [(ngModel)]="rightValue">
                    <button *ngIf="rightValue != ''" matSuffix mat-icon-button aria-label="Clear"
                        (click)="onClearRightValue()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </mat-card>
        <mat-card class="master-count__column master-count__in-cat">
            <div *ngIf="isLoading$ == false; else isLoadingGroup">
                <div *ngIf="type == 'category'; else areaBlock" id="masterSorter__rightSection">
                    <div [ngSwitch]="notInCat$.length">
                        <div *ngSwitchCase="0">
                            <app-no-results key="available">
                            </app-no-results>
                        </div>
                        <div *ngSwitchDefault>
                            <button class="masterSorter__available_item grey-hover masterSorter__rightRow" matRipple
                                [matRippleColor]="rippleAddColor" *ngFor="let p of notInCat$; let i = index"
                                (click)="onToggleRightSelection(i, null, p)"><span [innerHTML]="columns$.includes(3) ? p.prdCode : p.prdNameEn"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <ng-template #areaBlock>
                    <div *ngIf="notInCat$.length == 0 && uncategorized$.length == 0; else resultsBlock">
                        <div>
                            <app-no-results key="available">
                            </app-no-results>
                        </div>
                    </div>
                    <ng-template #resultsBlock>
                        <div id="masterSorter__rightSection">
                            <div *ngFor="let c of notInCat$; let i = index">
                                <div fxLayout="row" class="my-15" fxLayoutGap="20px" fxLayoutAlign="start center">
                                    <button type="button" mat-raised-button color="accent"
                                        (click)="onMoveCategoryItems(c, i)" [disabled]="c.products?.length == 0">≪ {{
                                        "moveAll" | translate }}</button>
                                    <div><strong class="masterSorter__pointer-item"><span [innerHTML]="c.prdCatNameEn"></span></strong>
                                    </div>
                                </div>
                                <button class="masterSorter__available_item grey-hover masterSorter__rightRow" matRipple
                                    [matRippleColor]="rippleAddColor" *ngFor="let p of c.products; let j = index"
                                    (click)="onToggleRightSelection(i, j, p)">
                                    <span [innerHTML]="columns$.includes(3) ? p.prdCode : p.prdNameEn"></span>
                                </button>
                            </div>
                            <div>
                                <div fxLayout="row" class="my-15" fxLayoutGap="20px" fxLayoutAlign="start center">
                                    <button type="button" mat-raised-button color="accent"
                                        (click)="onMoveUncategorizedItems()" style="min-width: 100.176px;"
                                        [disabled]="uncategorized$.length == 0">≪
                                        {{ "moveAll" | translate }}</button>
                                    <div><strong>{{ "uncategorizedProducts" | translate }}</strong></div>
                                </div>
                                <div *ngFor="let p of uncategorized$; let i = index">
                                    <button class="masterSorter__available_item grey-hover" matRipple
                                        [matRippleColor]="rippleAddColor" (click)="onRemoveFromUncategorized(i, p)">
                                        <span [innerHTML]="columns$.includes(3) ? p.prdCode : p.prdNameEn"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </mat-card>
    </div>
</div>
